import React, { useState, ReactNode } from "react";
import { Dialog } from "@reach/dialog";
import { TextOnly } from "./Text";

interface ConfirmModalProps {
  showConfirmModal: boolean;
  closeModal: Function;
  onConfirm: Function;
  textModal: string | ReactNode;
  className?: string;
  titleModal?: string;
  secondaryTextModal?: string | ReactNode;
  textConfirmButton?: string;
  textCancelButton?: string;
  textLoadingConfirmButton?: string;
  singleAction?: boolean;
  headerIcon?: string;
}
const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    showConfirmModal,
    closeModal,
    onConfirm,
    textModal,
    className,
    titleModal,
    secondaryTextModal,
    textConfirmButton,
    textCancelButton,
    textLoadingConfirmButton,
    singleAction=false,
    headerIcon=undefined,
  } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCloseModal = () => {
    document.querySelector('.c-modal')?.classList.add('closed');
    setTimeout(() => {
      closeModal();
    }, 350);
  }

  const handleOnConfirm = async() => {
    setIsLoading(true);
    await onConfirm();
    setIsLoading(false);
    handleCloseModal();
  }

  return (
    <Dialog
      isOpen={showConfirmModal}
      onDismiss={handleCloseModal}
      className={className ?? "c-modal"}
      aria-label="ConfirmModal"
    >
      <div className="l-flex-column l-flex-align-center">
        <button
          className="c-btn-icon c-modal__close"
          onClick={handleCloseModal}
        >
          <div className="c-btn__inner">
            <i className="c-btn__icon fal fa-times" />
          </div>
        </button>
        <h1 className='c-modal__heading'>
          {titleModal ? titleModal : TextOnly('confirm')}
        </h1>
        <div>
          <div className="c-modal__body">
            <div className="l-flex-gap-1">
              <div>
                {textModal}
              </div>
              {secondaryTextModal && (
                <div>
                  {secondaryTextModal}
                </div>
              )}
            </div>
            <div className="u-margin-top-large l-container-center">
            {!singleAction ?
              <button
                className="c-btn-outline u-margin-right-large"
                disabled={isLoading}
                onClick={handleCloseModal}
              >
                {textCancelButton ?? <span>{TextOnly('cancel')}</span>}
              </button>
              :
              null
            }

            {onConfirm &&
              <button
                className="c-btn"
                disabled={isLoading}
                onClick={handleOnConfirm}
              >
                { isLoading ?
                  textLoadingConfirmButton ?? <span>{TextOnly('loading')}</span>
                  : textConfirmButton ?? <span>{TextOnly('confirm')}</span>
                }
              </button>
            }
          </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ConfirmModal;
